module.exports = __webpack_public_path__ + "media/images/reserve_logo-917d5d4115a4e3bcef30e80f6b4ae19d.png";